import { render, staticRenderFns } from "./AnlingChaiLing.vue?vue&type=template&id=381bc5a0&"
import script from "./AnlingChaiLing.vue?vue&type=script&lang=js&"
export * from "./AnlingChaiLing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports